import React, { Component } from 'react';
import { times } from 'lodash';

import DotLoader from '../../assets/images/animated_svgs/grow_shrink_dot.svg';

const MAX_DOTS = 3;

// NOTE: If you are clearing up this file after the tailwind migration,
//       consider if we need it at all.
//       Is it just serving the animated dot loader?
export default class Loading extends Component {
  constructor() {
    super();

    this.state = {
      dots: 0
    };
  }

  componentDidMount() {
    const interval = setInterval(this.updateDots.bind(this), 500);
    this.setState({ interval });
  }

  componentWillUnmount() {
    clearInterval(this.state.interval);
  }

  updateDots() {
    this.setState({ dots: (this.state.dots + 1) % (MAX_DOTS + 1) });
  }

  dots() {
    return times(MAX_DOTS, (i) => (
      <span key={i} className={`loading__dot ${i < this.state.dots ? 'loading__dot--visible' : null}`}>&bull;</span>
    ));
  }

  render() {
    return (
      <div className='flex justify-center py-1'>
        <DotLoader width={30} height={30} />
      </div>
    );
  }
}
